export default __webpack_public_path__ + "static/logo-greenpeace-c06ec33ab1cc4d2b441c1e109eb750d9.png";